export const storage = {
  getValue(key: string): string | null {
    if (typeof window === 'undefined') return null

    return localStorage.getItem(key)
  },

  setValue(key: string, value: string): boolean {
    if (typeof window === 'undefined') return false

    localStorage.setItem(key, value)
    return true
  },
}
